import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/css/css.js";

export default obj => {
	obj.each(function () {
		const label = $(this),
			target = $("#" + label.attr("aria-controls"));
		$("#" + label.attr("for")).on("change", function () { // whenther checkbox is toggled
			requestAnimationFrame(() => { // request frame to set the initial height before collapsing, otherwise it jumps
				target.css("max-height", "none"); // disable CSS max-height transition
				target.css("height", target.get(0).scrollHeight);
				if (!this.checked) {
					requestAnimationFrame(() => target.css("height", 0));
				} else {
					setTimeout(() => target.css("height", ""), 500);
				}
			});
		});
	});
};